module.exports = __webpack_public_path__ + "static/pub-3e8f15bd574b6695882ff2958fdb542b.jpg";